import { render, staticRenderFns } from "./QuestionnaireFilePreviewModal.vue?vue&type=template&id=0197a17c&scoped=true&lang=pug"
import script from "./QuestionnaireFilePreviewModal.vue?vue&type=script&lang=ts"
export * from "./QuestionnaireFilePreviewModal.vue?vue&type=script&lang=ts"
import style0 from "./QuestionnaireFilePreviewModal.vue?vue&type=style&index=0&id=0197a17c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0197a17c",
  null
  
)

export default component.exports